export const INJECT_VIDEO_LOGO = 'inject video logo';

export interface InjectVideoLogoParams {
    videoPath: string;
}
export const injectVideoLogo = (params: InjectVideoLogoParams) => {
    const { videoPath } = params;
    return {
        type: INJECT_VIDEO_LOGO,
        videoPath,
    };
};
